class OrderNote {
    id = null;
    number = '';
    time_of_issue = null;
    currency = '';
    currency_rate = 1;
    amount = 0;
    tax_system = false;
    footer = '';
    user_id = null;
    supplier_id = null;
    supplier_data = {};
    sequence = 0;
    order_note_sequence_id = null;
    hash = '';
    items = [];
    locale = '';
    payment_details = '';
    delivery_details = '';
    show_financial_data = true;

    constructor(data, validation = false) {
        this.currency = 'EUR';

        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = '';
            }
        }
    }

    Fill(data) {
        for (const [key] of Object.entries(this)) {
            if (data[key] !== undefined) {
                this[key] = data[key];
            }
        }
    }
}

export default OrderNote;
